import { reuniaoService } from '../services/reuniao.service'
import SelectMultiple from './SelectMultiple'

export default {
	name: 'ModalFiltroCalendarioSai',
	props: {
		modelValue: {
			type: Object,
			default: () => ({
				officers: [],
	/* 			ano_inicio: null,
				mes_fim_ano_inicial: null,
				tem_atendimento: 'true',
				faixa_meses_sem_atendimento: '1,3', */
			}),
		},
		faixaMesesSemAtendimentoOptions: [],
		officersOptions: [],
	},
	components: {
		SelectMultiple,
	},

	data() {
		return {
			usuariosOptions: [],
		}
	},
	watch: {
 		'modelValue.faixa_meses_sem_atendimento': {
			immediate: true,
			handler(novo) {
				if (!novo) {
					this.$emit('update:modelValue', {
						...this.modelValue,
						faixa_meses_sem_atendimento: '1,3',
					})
				}
			},
		}, 
	},

	emits: ['update:modelValue', 'onClickAplicarFiltros', 'onClickLimparFiltros'],

	computed: {
		filtrosCalendarioFundacao: {
			get() {
				return this.modelValue
			},
			set(novoObjeto) {
				this.$emit('update:modelValue', { ...novoObjeto })
			},
		},
	},
	methods: {
		aplicarFiltros() {
			this.$emit('onClickAplicarFiltros')
		},
		limparFiltros() {
			this.$emit('onClickLimparFiltros')
		},
	},

	template: `
       <section
        class="modal--content rounded-md w-full !overflow-visible"
        data-id="reunioes_calendario_sai"
		id="reunioes_calendario_sai">
	<header
		class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
		<h2 class="text-lg font-medium text-white">Filtros</h2>
		<button
			type="button"
			class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
			data-xclose="modal_padrao_vue">
			<svg class="w-32 h-32">
				<use xlink:href="#icon_close"></use>
			</svg>
		</button>
	</header>
	<div class="flex flex-col gap-24 !p-24 w-full">
		<div class="flex flex-col gap-4 w-full">
			<label class="text-sm text-neutral-80 font-medium"> Officer: </label>

			<select-multiple
                :model="modelValue.officers"
				:options="officersOptions"
                @changed="(val) => modelValue.officers = val"
				:submitfc="() => {}">
			</select-multiple>
		</div>
		<div v-show="false" class="w-full grid grid-cols-2 gap-24 justify-between items-center">
			<div class="flex flex-col gap-4">
				<label class="text-sm text-neutral-80 font-medium"> De: </label>
				<input
					v-model="modelValue.ano_inicio"
					type="text"
					class="input-date border-2 rounded-[3px] !border-neutral-30 h-48 px-8"
					placeholder="MM/YYYY" />
			</div>
			<div class="flex flex-col gap-4">
				<label class="text-sm text-neutral-80 font-medium"> Até: </label>
				<input
					v-model="modelValue.mes_fim_ano_inicial"
					type="text"
					class="input-date border-2 rounded-[3px] !border-neutral-30 h-48 px-8"
					placeholder="MM/YYYY" />
			</div>
		</div>

		<div class="flex flex-col gap-4 w-full">
			<div v-if="false" class="inline-flex">
				<label class="text-sm text-neutral-80 font-medium mr-10">
					Possui Atendimento?
				</label>
				<div  class="text-sm text-neutral-80 font-medium">
					<q-radio v-model="modelValue.tem_atendimento" val="true" label="Sim" />
					<q-radio
						v-model="modelValue.tem_atendimento"
						val="false"
						class="ml-10"
						label="Não" />
				</div>
			</div>
		</div>

		<div v-if="false" class="flex flex-col gap-4 w-full">
			<label class="text-sm text-neutral-80 font-medium"> Período Último Atendimento: </label>

			 <q-select  
			 	v-model="modelValue.faixa_meses_sem_atendimento"  
				:options="faixaMesesSemAtendimentoOptions"  
				emit-value
				map-options
				outlined   />
		</div>
	</div>
	<div class="w-full flex gap-24 justify-between items-center p-24">
		<button
			type="button"
			class="btn h-48 secondary"
            @click="limparFiltros"
			>
			Limpar Filtros
		</button>
		<button
			type="button"
			class="btn h-48 primary"
            @click="aplicarFiltros"
			>
			Aplicar Filtros
		</button>
	</div>
</section>
    `,
}
